import {all} from "redux-saga/effects";
import {combineReducers} from "redux";

// Portal
import * as auth from "../app/modules/Auth/_redux/authRedux";
import {customersSlice} from "../app/modules/Portal/_redux/customers/customersSlice";
import {productsSlice} from "../app/modules/Portal/_redux/products/productsSlice";
import {remarksSlice} from "../app/modules/Portal/_redux/remarks/remarksSlice";
import {specificationsSlice} from "../app/modules/Portal/_redux/specifications/specificationsSlice";


// Admin
import {companiesSlice} from "../app/modules/Admin/_redux/clients/clientSlice";
import {companyProductsSlice} from "../app/modules/Admin/_redux/companyProducts/companyProductsSlice";
import {companyUsersSlice} from "../app/modules/Admin/_redux/companyUsers/companyUsersSlice";
import {companyBrandsSlice} from "../app/modules/Admin/_redux/companyBrands/companyBrandsSlice";
import {companyCategoriesSlice} from "../app/modules/Admin/_redux/companyCategories/companyCategoriesSlice";
import {brandsSlice} from "../app/modules/Portal/_redux/brands/brandsSlice";
import {categoriesSlice} from "../app/modules/Portal/_redux/categories/categoriesSlice";


import {recipesSlice} from "../app/modules/Admin/_redux/recipes/recipesSlice";
import {usersSlice} from "../app/modules/Admin/_redux/users/usersSlice";
import {rolesSlice} from "../app/modules/Admin/_redux/roles/rolesSlice";
import {adminProductsSlice} from "../app/modules/Admin/_redux/products/adminProductsSlice";

export const rootReducer = combineReducers({
  auth: auth.reducer,
  // Portal
  customers: customersSlice.reducer,
  products: productsSlice.reducer,
  remarks: remarksSlice.reducer,
  specifications: specificationsSlice.reducer,
  brands: brandsSlice.reducer,
  categories: categoriesSlice.reducer,
  // Admin
  companies: companiesSlice.reducer,
  companyUsers: companyUsersSlice.reducer,
  companyProducts: companyProductsSlice.reducer,
  companyBrands: companyBrandsSlice.reducer,
  companyCategories: companyCategoriesSlice.reducer,
  recipes: recipesSlice.reducer,
  users: usersSlice.reducer,
  roles: rolesSlice.reducer,
  adminProducts: adminProductsSlice.reducer
});

export function* rootSaga() {
  yield all([auth.saga()]);
}
